import { OperationalEquipmentDto, WorkAreaType } from '@operations/app/api'
import {
  ICarrierVisitAssignment,
  IYardBlockAssignment,
} from '../models/operational-equipment-assignment.model'

export const mapFromOperationEquipmentsToCarrierVisitAssignments = (
  operationalEquipments: OperationalEquipmentDto[],
  workAreaType: WorkAreaType,
): ICarrierVisitAssignment[] =>
  operationalEquipments
    .flatMap(x => x.assignments)
    .filter(x => x && x.carrierVisit && x.workAreaType === workAreaType)
    .map(
      x =>
        ({
          filter: x!.carrierVisit?.carrierName,
          visitId: x?.carrierVisit?.id,
          workAreaId: x!.workAreaId,
          workAreas: [],
          isDeleted: false,
        }) as ICarrierVisitAssignment,
    )
    .sort((a, b) => (a.filter || '').localeCompare(b.filter || ''))

export const mapFromOperationEquipmentsToYardBlockAssignments = (
  operationalEquipments: OperationalEquipmentDto[],
): IYardBlockAssignment[] =>
  operationalEquipments
    .flatMap(x => x.assignments)
    .filter(x => x && x.yardBlock && x.workAreaType === WorkAreaType.Yard)
    .map(
      x =>
        ({
          filter: x!.yardBlock?.name,
          workAreaId: x!.workAreaId,
          assignedBays: x!.assignedBays,
          bays: x!.yardBlock?.bays,
          isDeleted: false,
        }) as IYardBlockAssignment,
    )
    .sort((a, b) => (a.filter || '').localeCompare(b.filter || ''))
